import { render, staticRenderFns } from "./BulkAddModal.vue?vue&type=template&id=5b4d9ede"
import script from "./BulkAddModal.vue?vue&type=script&lang=js"
export * from "./BulkAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports